export default __webpack_public_path__ + "static/media/SDG-icon-NL-07.427e5835.svg";